import React, {
    useContext,
    useEffect,
    useState
} from 'react';
import { useRouter } from 'next/router';

import { Typography } from '@mui/material';
import { styled } from '@mui/material/styles';

import { RequestNextApi } from '../../../../api/Request';
import { ProgressContext } from '../../../../components/Context/progressContext';
import Header from '../../../../components/Header';
import { communityNavigation } from '../../../../navigation/community';
import { headerLink } from '../../../../navigation/function';
import { getCookie } from '../../../../utils/cookieHandle';
import { ShowNotification } from '../../../../utils/notification/snackbarUtils';
import {ARTICLE_BLOCKS_TYPE} from '../../../../utils/static-pages/model';

export default function MyStudyGroups() {
    const { state: progressContext, update: updateProgress } = useContext(ProgressContext);
    const [studyGroups, setStudyGroups] = useState();

    const router = useRouter();

    const communityLink = headerLink(communityNavigation.community);
    const myStudyGroupsLink = headerLink(communityNavigation.myStudyGroups, true);

    useEffect(() => {
        fetchStudyGroups();
    }, []);

    const fetchStudyGroups = async () => {
        updateProgress({ isLoading: true });
        try {
            const result = await RequestNextApi.post('/user/user-fetch2',
                {
                    jwtToken: getCookie('jwt-token')
                }
            );
            if (result.data.success) {
                setStudyGroups(result.data.user.studyGroups);
            } else {
                ShowNotification.error(result.data.message);
            }
        } catch (error) {
            ShowNotification.error('Group fetch failed');
        }
        updateProgress({ isLoading: false });
    };

    const handleClickGroup = (studyGroup) => {
        router.push(
            {
                pathname: `${communityNavigation.myStudyGroups.href}/${studyGroup.id}`
            },
        );
    };

    return (
        <div class="py-2 rounded-xl mx-auto max-w-7xl px-0">
            <Header>
                <div>Members | {communityLink} | {myStudyGroupsLink}</div>
            </Header>
            <div className='mt-5'>                
                 <img
                    className="h-full w-full object-cover"
                    src="https://kawebresources.s3.amazonaws.com/siteimages/img-MemberHeaders-MyStudyGroup-1290x325.png"
                    alt="My Study Group"
                 />
            </div>
            <div className='mt-5'>
                <Typography className='text-xl'>
                    Click the name of your Study Group below to see meeting details or contact your group leader.
                </Typography>
            </div>
            {studyGroups?.length > 0 ? (
                <div className='mx-5 mt-8'>
                    {studyGroups.map((item, index) => (
                        <Typography
                            key={index}
                            gutterBottom variant="h6"
                            component="div"
                            className='cursor-pointer underline'
                            onClick={() => handleClickGroup(item)}
                        >
                            {item.name}
                        </Typography>
                    ))}
                </div>
            ) : (
                <Typography className='mx-5 mt-8'>
                    No groups found
                </Typography>
            )}
        </div>
    )
}
